import { ReactComponent as EditIcon } from "assets/images/icons/btn_edit.svg";
import { ReactComponent as RemoveIcon } from "assets/images/icons/icn_btn_bin.svg";
import { ReactComponent as RemoveHoverIcon } from "assets/images/icons/icn_btn_bin_hover.svg";

import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Tooltip, Typography } from "@mui/material";

const ActionIcons = ({ rowData, editMacAddressProfile, deleteMacAddressProfile, showEditGeneral }) => {
  const [isRemoveHovered, setIsRemoveHovered] = useState(false);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <EditIcon
        onClick={() => editMacAddressProfile(rowData)}
        style={{ cursor: 'pointer', margin: '0 6px 0 2px', width: '18px', height: '18px' }}
      />
      {showEditGeneral && (
        <>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: "primary.greyThread",
              height: "20px",
              width: "1px",
              margin: "0 10px",
            }}
          />
          <Box
            onMouseEnter={() => setIsRemoveHovered(true)}
            onMouseLeave={() => setIsRemoveHovered(false)}
            onClick={() => deleteMacAddressProfile(rowData)}
            sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >
            {isRemoveHovered ? (
              <RemoveHoverIcon style={{ width: '20px', height: '20px', margin: '0 6px 0 2px' }} />
            ) : (
              <RemoveIcon style={{ width: '20px', height: '20px', margin: '0 6px 0 2px' }} />
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

const EllipsisTooltipCell = ({ text }) => {
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflow(element.scrollWidth > element.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip
      title={
        isOverflow
          ? (
            <Typography sx={{ whiteSpace: "normal" }}>
              {text || "-"}
            </Typography>
          )
          : ""
      }
      disableHoverListener={!isOverflow}
      arrow
    >
      <Box
        ref={textRef}
        sx={{
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text || "-"}
      </Box>
    </Tooltip>
  );
};

export const getTableColumns = (theme, columnHelper, showEditGeneral, editMacAddressProfile, deleteMacAddressProfile) => [
  columnHelper.accessor('macGroupName', {
    header: 'MAC Group Name',
    meta: {},
    cell: info => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <EllipsisTooltipCell text={info.getValue()} />
      </Box>
    )
  }),
  columnHelper.accessor('macs', {
    header: 'MACs',
    meta: {},
    cell: info => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {info.getValue()}
      </Box>
    )
  }),
  // Action column
  columnHelper.display({
    id: 'action',
    header: 'Action',
    meta: { isAction: true },
    cell: info => {
      const rowData = info.row.original;

      return (
        <ActionIcons
          rowData={rowData}
          editMacAddressProfile={editMacAddressProfile}
          deleteMacAddressProfile={deleteMacAddressProfile}
          showEditGeneral={showEditGeneral}
        />
      );
    }
  })
].filter(Boolean);

// export const getModalTableColumns = (
//   columnHelper,
//   form,
//   changeMacAddressItemValue,
//   changeDescriptionItemValue,
// ) => [
//   CheckboxColumn(columnHelper, null, {
//     getRowDisabled: (row, table) => {
//       const selectedRows = table.getSelectedRowModel().rows;
//       if (selectedRows.length === 0) return false;
//       const lockedStatus = selectedRows[0].original.siteName;
//       return row.siteName !== lockedStatus;
//     },
//   }),
//   columnHelper.accessor('macAddress', {
//     header: 'MAC Address',
//     cell: info => (
//       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//         <MacAddressInputField
//           value={info.getValue()}
//           disabled={false}
//           onChange={(newVal) => {
//             info.row.original = newVal;
//             changeMacAddressItemValue(info.row.index, 'macAddress', newVal);
//           }}
//         />
//       </Box>
//     )
//   }),
//   columnHelper.accessor('description', {
//     header: 'Description',
//     cell: info => (
//       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//         <TextField
//           placeholder=""
//           sx={form.getTextfieldStyle(true)}
//           value={info.getValue()}
//           onChange={(e) => {
//             info.row.original = e.target.value;
//             changeDescriptionItemValue(info.row.index, 'description', e.target.value);
//           }}
//         />
//       </Box>
//     )
//   }),
// ].filter(Boolean);

export const fromJSON = (data) => {
  return {
    id: data.id,
    macGroupName: data.name,
    macs: data.macList.length,
    ref: data,
  }
}

export const toJSON = (data, id = null) => {
  if (id) {
    return {
      id,
      name: data.name,
      macList: data.macAddresses,
    }
  }

  return {
    name: data.name,
    macList: data.macAddresses,
  }
}